import { useEffect, useState } from "react";
import { Card, Table } from "react-bootstrap";
import {
    useParams
} from "react-router-dom";
import { db } from '../../../firebase';
import Rubber from "./rubber";

/*
    Contain all results between two teams ie. multiple rubbers 
    No more navbars and routes. Display everything in one screen
*/
export default function Match(props) {
    let { id } = useParams()

    let [loading, setLoading] = useState(true)

    // add thisplayers
    let [isMode2, setisMode2] = useState(false)
    let [t1p1, sett1p1] = useState(null) // team 1 player 1
    let [t1p2, sett1p2] = useState(null)
    let [t1p3, sett1p3] = useState(null)
    let [t2p1, sett2p1] = useState(null) // team 2 player 1
    let [t2p2, sett2p2] = useState(null)
    let [t2p3, sett2p3] = useState(null)

    let [thisPlayers, setthisPlayers] = useState({})
    let [rubbers, setrubbers] = useState([])
    let [rubberResults, setrubberResults] = useState({})
    let [editRubbers, seteditRubbers] = useState([])

    let [r1s1, setr1s1] = useState(null)
    let [r2s1, setr2s1] = useState(null)
    let [r3s1, setr3s1] = useState(null)
    let [r4s1, setr4s1] = useState(null)
    let [r5s1, setr5s1] = useState(null)
    let [r6s1, setr6s1] = useState(null)

    let [r1s2, setr1s2] = useState(null)
    let [r2s2, setr2s2] = useState(null)
    let [r3s2, setr3s2] = useState(null)
    let [r4s2, setr4s2] = useState(null)
    let [r5s2, setr5s2] = useState(null)
    let [r6s2, setr6s2] = useState(null)

    let matchRef = db.collection("seasons").doc(props.seasonID)
        .collection("days").doc(props.dayID).collection("matches").doc(id)

    let availabilityDBRef = db.collection("seasons").doc(props.seasonID)
        .collection("days").doc(props.dayID)
        .collection("availability")

    // return all players in this match
    function getthisPlayers() {
        setLoading(true)
        matchRef.get()
            .then((doc) => {
                if (doc.data().thisPlayers) {
                    let resthisPlayers = doc.data().thisPlayers
                    let toDspPlys = {
                        "t1p1": resthisPlayers["t1p1"],
                        "t1p2": resthisPlayers["t1p2"],
                        "t1p3": resthisPlayers["t1p3"],
                        "t2p1": resthisPlayers["t2p1"],
                        "t2p2": resthisPlayers["t2p2"],
                        "t2p3": resthisPlayers["t2p3"],
                    }
                    setthisPlayers(toDspPlys)
                } else {
                    setthisPlayers({})
                }
                setLoading(false)
            })
            .catch((e) => {
                console.log(e)
                setLoading(false)
            })
    }

    // onLoad
    function updatePlyRefs() {
        sett1p1(thisPlayers["t1p1"])
        sett1p2(thisPlayers["t1p2"])
        sett1p3(thisPlayers["t1p3"])
        sett2p1(thisPlayers["t2p1"])
        sett2p2(thisPlayers["t2p2"])
        sett2p3(thisPlayers["t2p3"])
    }

    function getRubResults() {
        setLoading(true)
        matchRef.get()
            .then((doc) => {
                console.log(doc.data())

                if (doc.data().isMode2) {
                    setisMode2(true)
                    if (doc.data().results) {
                        let resRst = doc.data().results
                        let toDspRst = {
                            "r1s1": resRst["r1s1"],
                            "r1s2": resRst["r1s2"],
                            "r2s1": resRst["r2s1"],
                            "r2s2": resRst["r2s2"],
                            "r3s1": resRst["r3s1"],
                            "r3s2": resRst["r3s2"],

                            "r4s1": resRst["r4s1"],
                            "r4s2": resRst["r4s2"],
                            "r5s1": resRst["r5s1"],
                            "r5s2": resRst["r5s2"],
                        }
                        setrubberResults(toDspRst)
                    } else {
                        setrubberResults({})
                    }
                }
                else {
                    setisMode2(false)
                    if (doc.data().results) {
                        let resRst = doc.data().results
                        let toDspRst = {
                            "r1s1": resRst["r1s1"],
                            "r1s2": resRst["r1s2"],
                            "r2s1": resRst["r2s1"],
                            "r2s2": resRst["r2s2"],
                            "r3s1": resRst["r3s1"],
                            "r3s2": resRst["r3s2"],

                            "r4s1": resRst["r4s1"],
                            "r4s2": resRst["r4s2"],
                            "r5s1": resRst["r5s1"],
                            "r5s2": resRst["r5s2"],
                            "r6s1": resRst["r6s1"],
                            "r6s2": resRst["r6s2"],
                        }
                        setrubberResults(toDspRst)
                    } else {
                        setrubberResults({})
                    }
                }
                setLoading(false)
            })
            .catch((e) => {
                console.log(e)
                setLoading(false)
            })
    }

    // generate rubbers with the players added
    /*
        rubber1 : #1 single
        rubber2 : #2 single
        rubber3 : #3 single
        rubber4 : #1#2 double
        rubber5 : #1#3 double
        rubber6 : #2#3 double
    */
    function genRubbers() {
        let newrubbers = [
            ["rubber1", [thisPlayers["t1p1"]], [thisPlayers["t2p1"]], rubberResults["r1s1"], rubberResults["r1s2"]],
            ["rubber2", [thisPlayers["t1p2"]], [thisPlayers["t2p2"]], rubberResults["r2s1"], rubberResults["r2s2"]],
            ["rubber3", [thisPlayers["t1p3"]], [thisPlayers["t2p3"]], rubberResults["r3s1"], rubberResults["r3s2"]],

            ["rubber4", [thisPlayers["t1p1"], thisPlayers["t1p2"]], [thisPlayers["t2p1"], thisPlayers["t2p2"]], rubberResults["r4s1"], rubberResults["r4s2"]],
            ["rubber5", [thisPlayers["t1p1"], thisPlayers["t1p3"]], [thisPlayers["t2p1"], thisPlayers["t2p3"]], rubberResults["r5s1"], rubberResults["r5s2"]],
            ["rubber6", [thisPlayers["t1p2"], thisPlayers["t1p3"]], [thisPlayers["t2p2"], thisPlayers["t2p3"]], rubberResults["r6s1"], rubberResults["r6s2"]],
        ]
        setrubbers(newrubbers)
    }

    function genRubbersMode2() {
        let newrubbers = [
            ["rubber1", [thisPlayers["t1p1"]], [thisPlayers["t2p1"]], rubberResults["r1s1"], rubberResults["r1s2"]],
            ["rubber2", [thisPlayers["t1p1"]], [thisPlayers["t2p2"]], rubberResults["r2s1"], rubberResults["r2s2"]],

            ["rubber3", [thisPlayers["t1p2"]], [thisPlayers["t2p1"]], rubberResults["r3s1"], rubberResults["r3s2"]],
            ["rubber4", [thisPlayers["t1p2"]], [thisPlayers["t2p2"]], rubberResults["r4s1"], rubberResults["r4s2"]],

            ["rubber5", [thisPlayers["t1p1"], thisPlayers["t1p2"]], [thisPlayers["t2p1"], thisPlayers["t2p2"]], rubberResults["r5s1"], rubberResults["r5s2"]],
        ]
        setrubbers(newrubbers)
    }

    function genEditRubbers() {
        let newrubbers = [
            ["rubber1", [thisPlayers["t1p1"]], [thisPlayers["t2p1"]], [r1s1, setr1s1], [r1s2, setr1s2]],
            ["rubber2", [thisPlayers["t1p2"]], [thisPlayers["t2p2"]], [r2s1, setr2s1], [r2s2, setr2s2]],
            ["rubber3", [thisPlayers["t1p3"]], [thisPlayers["t2p3"]], [r3s1, setr3s1], [r3s2, setr3s2]],
            ["rubber4", [thisPlayers["t1p1"], thisPlayers["t1p2"]], [thisPlayers["t2p1"], thisPlayers["t2p2"]], [r4s1, setr4s1], [r4s2, setr4s2]],
            ["rubber5", [thisPlayers["t1p1"], thisPlayers["t1p3"]], [thisPlayers["t2p1"], thisPlayers["t2p3"]], [r5s1, setr5s1], [r5s2, setr5s2]],
            ["rubber6", [thisPlayers["t1p2"], thisPlayers["t1p3"]], [thisPlayers["t2p2"], thisPlayers["t2p3"]], [r6s1, setr6s1], [r6s2, setr6s2]],
        ]
        seteditRubbers(newrubbers)
    }

    function genEditRubbersMode2() {
        let newrubbers = [
            ["rubber1", [thisPlayers["t1p1"]], [thisPlayers["t2p1"]], [r1s1, setr1s1], [r1s2, setr1s2]],
            ["rubber2", [thisPlayers["t1p1"]], [thisPlayers["t2p2"]], [r2s1, setr2s1], [r2s2, setr2s2]],
            ["rubber3", [thisPlayers["t1p2"]], [thisPlayers["t2p1"]], [r3s1, setr3s1], [r3s2, setr3s2]],
            ["rubber4", [thisPlayers["t1p2"]], [thisPlayers["t2p2"]], [r4s1, setr4s1], [r4s2, setr4s2]],
            ["rubber5", [thisPlayers["t1p1"], thisPlayers["t1p2"]], [thisPlayers["t2p1"], thisPlayers["t2p2"]], [r5s1, setr5s1], [r5s2, setr5s2]],
        ]
        seteditRubbers(newrubbers)
    }

    function newRubber(name, t1players, t2players, t1score, t2score) {
        return <Rubber name={name} t1players={t1players} t2players={t2players} t1score={t1score} t2score={t2score} ></Rubber>
    }

    useEffect(() => {
        if (isMode2) { genEditRubbersMode2() }
        else { genEditRubbers() }
    }, [r1s1, r1s2, r2s1, r2s2,
        r3s1, r3s2, r4s1, r4s2,
        r5s1, r5s2, r6s1, r6s2])

    useEffect(() => {
        updatePlyRefs()
        if (isMode2) {
            genRubbersMode2()
            genEditRubbersMode2()
        }
        else {
            genRubbers()
            genEditRubbers()
        }

    }, [thisPlayers, rubberResults])

    useEffect(() => {
        getthisPlayers()

        genRubbers()
        genEditRubbers()
        getRubResults()
    }, [id])


    const displayRubbers = rubbers.map((elem, ind) => {
        let name = elem[0]
        let t1players = elem[1]
        let t2players = elem[2]
        let t1score = elem[3]
        let t2score = elem[4]
        return (
            <div key={ind}>
                {newRubber(name, t1players, t2players, t1score, t2score)}
            </div>
        )
    })

    const displaythisPlayers = Object.keys(thisPlayers).map((key) => {
        if (thisPlayers[key]) {
            return (
                <tr>
                    <td>{key}</td>
                    <td>{thisPlayers[key] ? thisPlayers[key].player.displayName : "null"}</td>
                </tr>
            )
        }
    })

    const displayMatch = (
        <div>
            {thisPlayers == null ? <div>No players has been added</div>
                :
                <div className="scoreboard-container center">
                    <Card className="scoreboard center">
                        <Card.Body>
                            <Table striped bordered hover size="sm">
                                <thead>
                                    <tr>
                                        <th>Position</th>
                                        <th>Player name</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {displaythisPlayers}
                                </tbody>
                            </Table>
                        </Card.Body>
                    </Card>

                </div>
            }

            <div className="scoreboard-container center">
                {displayRubbers}
            </div>
        </div>
    )

    return (
        <div className="margin">
            {displayMatch}
        </div>
    )

}